import { isZh } from "./language";

/* ================= TEMPLATE ENGINE ================= */

export function renderTemplate(text,vars){

  if(!text) return "";

  return text.replace(/\{\{(.*?)\}\}/g,(m,k)=>{

    const key = k.trim();

    let val = vars[key] ?? "";

    // convert line break → <br/>
    if(typeof val === "string"){
      val = val.replace(/\n/g,"<br/>");
    }

    return val;

  });

}

/* ================= DATE ================= */

export function addDays(date,days){

  const d=new Date(date);

  d.setDate(d.getDate()+days);

  return d;

}

export function formatDate(d){

  const dt=new Date(d);

  const y=dt.getFullYear();
  const m=String(dt.getMonth()+1).padStart(2,"0");
  const day=String(dt.getDate()).padStart(2,"0");

  return `${y}-${m}-${day}`;

}

export function getWeekday(date){

  const zh = ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
  const id = ["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"];

  const d = new Date(date).getDay();

  return {
    zh: zh[d],
    id: id[d]
  };

}

/* ================= ZH NUMBER ================= */

export function zhNumber(n){

  const map={
    1:"一",
    2:"二",
    3:"三",
    4:"四",
    5:"五",
    6:"六",
    7:"七",
    8:"八",
    9:"九",
    10:"十"
  };

  return map[n] || n;

}

/* ================= GENERIC TABLE ================= */

export function renderTable(rows,tableCfg,varsBuilder){

  if(!tableCfg) return null;

  const columns =
    (tableCfg.columns || []).filter(c=>c.show!==false);

  return (

    <table className="report-table">

      <thead>
        <tr>

          {columns.map(col=>(
						<th
							key={col.key}
							style={{
								width:col.width,
								textAlign:col.headerAlign || "center"
							}}
							dangerouslySetInnerHTML={{
								__html:
									col.headerTemplate
										? renderTemplate(col.headerTemplate,col)
										: `${col.labelZh || ""}<br/>${col.labelId || ""}`
							}}
						/>
					))}

        </tr>
      </thead>

      <tbody>

        {rows.map((row,i)=>{

          const vars = varsBuilder(row);

          return (

            <tr key={i}>

              {columns.map(col=>{

                const html =
                  renderTemplate(
                    col.template || `{{${col.key}}}`,
                    vars
                  );

                return (
                  <td
                    key={col.key}
										style={{textAlign:col.align || "left"}}
                    dangerouslySetInnerHTML={{__html:html}}
                  />
                );

              })}

            </tr>

          );

        })}

      </tbody>

    </table>

  );

}